var map = {
	"./botw/001-exterior.jpg": 43652,
	"./botw/001-interior.jpg": 56579,
	"./botw/001-title.jpg": 2819,
	"./botw/002-exterior.jpg": 61855,
	"./botw/002-interior.jpg": 86854,
	"./botw/002-title.jpg": 35108,
	"./botw/003-exterior.jpg": 44926,
	"./botw/003-interior.jpg": 82455,
	"./botw/003-title.jpg": 57960,
	"./botw/004-exterior.jpg": 72718,
	"./botw/004-interior.jpg": 41717,
	"./botw/004-title.jpg": 52638,
	"./botw/005-exterior.jpg": 92794,
	"./botw/005-interior.jpg": 16801,
	"./botw/005-title.jpg": 5015,
	"./botw/006-exterior.jpg": 26136,
	"./botw/006-interior.jpg": 82950,
	"./botw/006-title.jpg": 2024,
	"./botw/007-exterior.jpg": 75875,
	"./botw/007-interior.jpg": 57741,
	"./botw/007-title.jpg": 81359,
	"./botw/008-exterior.jpg": 82604,
	"./botw/008-interior.jpg": 30933,
	"./botw/008-title.jpg": 507,
	"./botw/009-exterior.jpg": 70987,
	"./botw/009-interior.jpg": 42272,
	"./botw/009-title.jpg": 81136,
	"./botw/010-exterior.jpg": 1227,
	"./botw/010-interior.jpg": 57373,
	"./botw/010-title.jpg": 53159,
	"./botw/011-exterior.jpg": 69674,
	"./botw/011-title.jpg": 97149,
	"./botw/012-exterior.jpg": 90831,
	"./botw/012-interior.jpg": 75299,
	"./botw/012-quest.jpg": 38299,
	"./botw/012-title.jpg": 66576,
	"./botw/013-exterior.jpg": 40645,
	"./botw/013-interior.jpg": 2001,
	"./botw/013-quest.jpg": 76942,
	"./botw/013-title.jpg": 20616,
	"./botw/014-exterior.jpg": 82741,
	"./botw/014-interior.jpg": 83000,
	"./botw/014-title.jpg": 25737,
	"./botw/015-exterior.jpg": 66411,
	"./botw/015-interior.jpg": 57413,
	"./botw/015-title.jpg": 30956,
	"./botw/016-exterior.jpg": 30451,
	"./botw/016-interior.jpg": 60234,
	"./botw/016-quest.jpg": 2416,
	"./botw/016-title.jpg": 55577,
	"./botw/017-exterior.jpg": 42489,
	"./botw/017-interior.jpg": 60531,
	"./botw/017-quest.jpg": 92129,
	"./botw/017-title.jpg": 1726,
	"./botw/018-exterior.jpg": 43509,
	"./botw/018-interior.jpg": 57190,
	"./botw/018-title.jpg": 27837,
	"./botw/019-exterior.jpg": 34900,
	"./botw/019-interior.jpg": 22945,
	"./botw/019-quest.jpg": 24512,
	"./botw/019-title.jpg": 35949,
	"./botw/020-exterior.jpg": 44537,
	"./botw/020-interior.jpg": 36837,
	"./botw/020-quest.jpg": 83117,
	"./botw/020-title.jpg": 45242,
	"./botw/021-exterior.jpg": 25039,
	"./botw/021-interior.jpg": 22091,
	"./botw/021-title.jpg": 11510,
	"./botw/022-exterior.jpg": 66048,
	"./botw/022-interior.jpg": 22595,
	"./botw/022-title.jpg": 91611,
	"./botw/023-exterior.jpg": 55374,
	"./botw/023-interior.jpg": 26946,
	"./botw/023-title.jpg": 29564,
	"./botw/024-exterior.jpg": 8789,
	"./botw/024-interior.jpg": 39331,
	"./botw/024-title.jpg": 5405,
	"./botw/025-exterior.jpg": 45451,
	"./botw/025-interior.jpg": 37685,
	"./botw/025-title.jpg": 80061,
	"./botw/026-exterior.jpg": 12732,
	"./botw/026-interior.jpg": 94300,
	"./botw/026-quest.jpg": 79016,
	"./botw/026-title.jpg": 67958,
	"./botw/027-exterior.jpg": 27896,
	"./botw/027-interior.jpg": 84972,
	"./botw/027-quest.jpg": 3765,
	"./botw/027-title.jpg": 37701,
	"./botw/028-exterior.jpg": 95450,
	"./botw/028-interior.jpg": 57458,
	"./botw/028-title.jpg": 24269,
	"./botw/029-exterior.jpg": 41504,
	"./botw/029-interior.jpg": 71748,
	"./botw/029-title.jpg": 75857,
	"./botw/030-exterior.jpg": 57629,
	"./botw/030-interior.jpg": 57670,
	"./botw/030-title.jpg": 40403,
	"./botw/031-exterior.jpg": 52962,
	"./botw/031-interior.jpg": 10686,
	"./botw/031-title.jpg": 10826,
	"./botw/032-exterior.jpg": 7763,
	"./botw/032-interior.jpg": 68473,
	"./botw/032-quest.jpg": 3754,
	"./botw/032-title.jpg": 74680,
	"./botw/033-exterior.jpg": 39763,
	"./botw/033-interior.jpg": 32425,
	"./botw/033-quest.jpg": 303,
	"./botw/033-title.jpg": 40958,
	"./botw/034-exterior.jpg": 91761,
	"./botw/034-interior.jpg": 90249,
	"./botw/034-title.jpg": 58546,
	"./botw/035-exterior.jpg": 7776,
	"./botw/035-interior.jpg": 42902,
	"./botw/035-quest.jpg": 5507,
	"./botw/035-title.jpg": 19677,
	"./botw/036-exterior.jpg": 46792,
	"./botw/036-interior.jpg": 73752,
	"./botw/036-quest.jpg": 90541,
	"./botw/036-title.jpg": 42549,
	"./botw/037-exterior.jpg": 63546,
	"./botw/037-interior.jpg": 85664,
	"./botw/037-title.jpg": 64565,
	"./botw/038-exterior.jpg": 32496,
	"./botw/038-interior.jpg": 24158,
	"./botw/038-title.jpg": 74049,
	"./botw/039-exterior.jpg": 1493,
	"./botw/039-interior.jpg": 86304,
	"./botw/039-title.jpg": 54114,
	"./botw/040-exterior.jpg": 56095,
	"./botw/040-interior.jpg": 60533,
	"./botw/040-title.jpg": 9562,
	"./botw/041-exterior.jpg": 76163,
	"./botw/041-interior.jpg": 53306,
	"./botw/041-title.jpg": 90130,
	"./botw/042-exterior.jpg": 92187,
	"./botw/042-title.jpg": 68607,
	"./botw/043-exterior.jpg": 80181,
	"./botw/043-interior.jpg": 27509,
	"./botw/043-title.jpg": 21506,
	"./botw/044-exterior.jpg": 40381,
	"./botw/044-interior.jpg": 4213,
	"./botw/044-title.jpg": 94203,
	"./botw/045-exterior.jpg": 24559,
	"./botw/045-interior.jpg": 54551,
	"./botw/045-title.jpg": 83034,
	"./botw/046-exterior.jpg": 99237,
	"./botw/046-interior.jpg": 21332,
	"./botw/046-title.jpg": 44333,
	"./botw/047-exterior.jpg": 99582,
	"./botw/047-interior.jpg": 24683,
	"./botw/047-quest.jpg": 23212,
	"./botw/047-title.jpg": 54541,
	"./botw/048-exterior.jpg": 63535,
	"./botw/048-interior.jpg": 39711,
	"./botw/048-title.jpg": 53767,
	"./botw/049-exterior.jpg": 7754,
	"./botw/049-interior.jpg": 21945,
	"./botw/049-title.jpg": 88592,
	"./botw/050-exterior.jpg": 19771,
	"./botw/050-interior.jpg": 39367,
	"./botw/050-title.jpg": 73257,
	"./botw/051-exterior.jpg": 79477,
	"./botw/051-interior.jpg": 50641,
	"./botw/051-quest.jpg": 19273,
	"./botw/051-title.jpg": 58301,
	"./botw/052-exterior.jpg": 19546,
	"./botw/052-interior.jpg": 41529,
	"./botw/052-title.jpg": 60520,
	"./botw/053-exterior.jpg": 32862,
	"./botw/053-interior.jpg": 72142,
	"./botw/053-quest.jpg": 62762,
	"./botw/053-title.jpg": 32629,
	"./botw/054-exterior.jpg": 55368,
	"./botw/054-interior.jpg": 7502,
	"./botw/054-title.jpg": 5388,
	"./botw/055-exterior.jpg": 29426,
	"./botw/055-interior.jpg": 66404,
	"./botw/055-quest.jpg": 80253,
	"./botw/055-title.jpg": 46326,
	"./botw/056-exterior.jpg": 29480,
	"./botw/056-interior.jpg": 94741,
	"./botw/056-title.jpg": 55554,
	"./botw/057-exterior.jpg": 496,
	"./botw/057-interior.jpg": 90073,
	"./botw/057-quest.jpg": 81553,
	"./botw/057-title.jpg": 36087,
	"./botw/058-exterior.jpg": 29217,
	"./botw/058-interior.jpg": 36928,
	"./botw/058-title.jpg": 72508,
	"./botw/059-exterior.jpg": 31352,
	"./botw/059-interior.jpg": 98762,
	"./botw/059-quest.jpg": 70969,
	"./botw/059-title.jpg": 20372,
	"./botw/060-exterior.jpg": 97666,
	"./botw/060-interior.jpg": 29830,
	"./botw/060-quest.jpg": 9583,
	"./botw/060-title.jpg": 29499,
	"./botw/061-exterior.jpg": 75181,
	"./botw/061-interior.jpg": 84993,
	"./botw/061-title.jpg": 34193,
	"./botw/062-exterior.jpg": 95779,
	"./botw/062-interior.jpg": 77893,
	"./botw/062-quest.jpg": 3242,
	"./botw/062-title.jpg": 64281,
	"./botw/063-exterior.jpg": 69881,
	"./botw/063-interior.jpg": 69633,
	"./botw/063-title.jpg": 89467,
	"./botw/064-exterior.jpg": 56225,
	"./botw/064-interior.jpg": 46866,
	"./botw/064-title.jpg": 16915,
	"./botw/065-exterior.jpg": 15365,
	"./botw/065-interior.jpg": 95038,
	"./botw/065-title.jpg": 4155,
	"./botw/066-exterior.jpg": 471,
	"./botw/066-interior.jpg": 17790,
	"./botw/066-quest.jpg": 77322,
	"./botw/066-title.jpg": 29632,
	"./botw/067-exterior.jpg": 61206,
	"./botw/067-interior.jpg": 51471,
	"./botw/067-title.jpg": 67620,
	"./botw/068-exterior.jpg": 30472,
	"./botw/068-interior.jpg": 23671,
	"./botw/068-quest.jpg": 71119,
	"./botw/068-title.jpg": 97137,
	"./botw/069-exterior.jpg": 11307,
	"./botw/069-interior.jpg": 90463,
	"./botw/069-title.jpg": 62830,
	"./botw/070-exterior.jpg": 94865,
	"./botw/070-interior.jpg": 49149,
	"./botw/070-quest.jpg": 18546,
	"./botw/070-title.jpg": 7135,
	"./botw/071-exterior.jpg": 64054,
	"./botw/071-title.jpg": 30624,
	"./botw/072-exterior.jpg": 14118,
	"./botw/072-interior.jpg": 74565,
	"./botw/072-title.jpg": 91425,
	"./botw/073-exterior.jpg": 81528,
	"./botw/073-interior.jpg": 75173,
	"./botw/073-title.jpg": 2027,
	"./botw/074-exterior.jpg": 86247,
	"./botw/074-interior.jpg": 32678,
	"./botw/074-title.jpg": 94381,
	"./botw/075-exterior.jpg": 48079,
	"./botw/075-interior.jpg": 72457,
	"./botw/075-quest.jpg": 65182,
	"./botw/075-title.jpg": 44276,
	"./botw/076-exterior.jpg": 98238,
	"./botw/076-interior.jpg": 31125,
	"./botw/076-title.jpg": 52434,
	"./botw/077-exterior.jpg": 22132,
	"./botw/077-interior.jpg": 82520,
	"./botw/077-title.jpg": 87862,
	"./botw/078-exterior.jpg": 34250,
	"./botw/078-interior.jpg": 51403,
	"./botw/078-title.jpg": 32958,
	"./botw/079-exterior.jpg": 1664,
	"./botw/079-interior.jpg": 30213,
	"./botw/079-quest.jpg": 28982,
	"./botw/079-title.jpg": 73892,
	"./botw/080-exterior.jpg": 21568,
	"./botw/080-interior.jpg": 3211,
	"./botw/080-title.jpg": 47740,
	"./botw/081-exterior.jpg": 41216,
	"./botw/081-interior.jpg": 67824,
	"./botw/081-title.jpg": 36320,
	"./botw/082-exterior.jpg": 59486,
	"./botw/082-interior.jpg": 56715,
	"./botw/082-title.jpg": 99218,
	"./botw/083-exterior.jpg": 98528,
	"./botw/083-interior.jpg": 40871,
	"./botw/083-title.jpg": 44104,
	"./botw/084-exterior.jpg": 53018,
	"./botw/084-interior.jpg": 25157,
	"./botw/084-title.jpg": 20609,
	"./botw/085-exterior.jpg": 61543,
	"./botw/085-interior.jpg": 33313,
	"./botw/085-title.jpg": 48170,
	"./botw/086-exterior.jpg": 11168,
	"./botw/086-interior.jpg": 36074,
	"./botw/086-title.jpg": 69457,
	"./botw/087-exterior.jpg": 70117,
	"./botw/087-interior.jpg": 4025,
	"./botw/087-quest.jpg": 53453,
	"./botw/087-title.jpg": 56544,
	"./botw/088-exterior.jpg": 89602,
	"./botw/088-interior.jpg": 89846,
	"./botw/088-title.jpg": 73491,
	"./botw/089-exterior.jpg": 38530,
	"./botw/089-interior.jpg": 6084,
	"./botw/089-quest.jpg": 30288,
	"./botw/089-title.jpg": 99951,
	"./botw/090-exterior.jpg": 66452,
	"./botw/090-interior.jpg": 66827,
	"./botw/090-quest.jpg": 8390,
	"./botw/090-title.jpg": 4978,
	"./botw/091-exterior.jpg": 58836,
	"./botw/091-interior.jpg": 48007,
	"./botw/091-quest.jpg": 52214,
	"./botw/091-title.jpg": 88477,
	"./botw/092-exterior.jpg": 3735,
	"./botw/092-interior.jpg": 24391,
	"./botw/092-quest.jpg": 57830,
	"./botw/092-title.jpg": 58149,
	"./botw/093-exterior.jpg": 93543,
	"./botw/093-interior.jpg": 27176,
	"./botw/093-title.jpg": 55315,
	"./botw/094-exterior.jpg": 66742,
	"./botw/094-interior.jpg": 68604,
	"./botw/094-quest.jpg": 62667,
	"./botw/094-title.jpg": 32569,
	"./botw/095-exterior.jpg": 24593,
	"./botw/095-interior.jpg": 19770,
	"./botw/095-quest.jpg": 17399,
	"./botw/095-title.jpg": 95946,
	"./botw/096-exterior.jpg": 73521,
	"./botw/096-interior.jpg": 69780,
	"./botw/096-title.jpg": 52471,
	"./botw/097-exterior.jpg": 65752,
	"./botw/097-interior.jpg": 8528,
	"./botw/097-title.jpg": 1025,
	"./botw/098-exterior.jpg": 58268,
	"./botw/098-interior.jpg": 44870,
	"./botw/098-quest.jpg": 84482,
	"./botw/098-title.jpg": 83953,
	"./botw/099-exterior.jpg": 21217,
	"./botw/099-interior.jpg": 77390,
	"./botw/099-title.jpg": 89598,
	"./botw/100-exterior.jpg": 41869,
	"./botw/100-interior.jpg": 45590,
	"./botw/100-title.jpg": 51623,
	"./botw/101-exterior.jpg": 34874,
	"./botw/101-interior.jpg": 27673,
	"./botw/101-quest.jpg": 50771,
	"./botw/101-title.jpg": 43571,
	"./botw/102-exterior.jpg": 74440,
	"./botw/102-interior.jpg": 20576,
	"./botw/102-quest.jpg": 42367,
	"./botw/102-title.jpg": 66139,
	"./botw/103-exterior.jpg": 10959,
	"./botw/103-interior.jpg": 15331,
	"./botw/103-title.jpg": 54839,
	"./botw/104-exterior.jpg": 95827,
	"./botw/104-interior.jpg": 73374,
	"./botw/104-title.jpg": 15054,
	"./botw/105-exterior.jpg": 96138,
	"./botw/105-interior.jpg": 95306,
	"./botw/105-title.jpg": 49124,
	"./botw/106-exterior.jpg": 62881,
	"./botw/106-interior.jpg": 46101,
	"./botw/106-title.jpg": 67822,
	"./botw/107-exterior.jpg": 70799,
	"./botw/107-interior.jpg": 50481,
	"./botw/107-quest.jpg": 10969,
	"./botw/107-title.jpg": 94403,
	"./botw/108-exterior.jpg": 60991,
	"./botw/108-interior.jpg": 11366,
	"./botw/108-title.jpg": 98240,
	"./botw/109-exterior.jpg": 35109,
	"./botw/109-interior.jpg": 31526,
	"./botw/109-title.jpg": 86378,
	"./botw/110-exterior.jpg": 22269,
	"./botw/110-interior.jpg": 84783,
	"./botw/110-quest.jpg": 36108,
	"./botw/110-title.jpg": 14209,
	"./botw/111-exterior.jpg": 77552,
	"./botw/111-interior.jpg": 59422,
	"./botw/111-quest.jpg": 63162,
	"./botw/111-title.jpg": 88846,
	"./botw/112-exterior.jpg": 19498,
	"./botw/112-interior.jpg": 57355,
	"./botw/112-title.jpg": 86705,
	"./botw/113-exterior.jpg": 31963,
	"./botw/113-interior.jpg": 30857,
	"./botw/113-quest.jpg": 55684,
	"./botw/113-title.jpg": 36706,
	"./botw/114-exterior.jpg": 54360,
	"./botw/114-interior.jpg": 1592,
	"./botw/114-title.jpg": 48389,
	"./botw/115-exterior.jpg": 4969,
	"./botw/115-interior.jpg": 49783,
	"./botw/115-title.jpg": 1178,
	"./botw/116-exterior.jpg": 1150,
	"./botw/116-interior.jpg": 81583,
	"./botw/116-quest.jpg": 41454,
	"./botw/116-title.jpg": 10046,
	"./botw/117-exterior.jpg": 38158,
	"./botw/117-interior.jpg": 78028,
	"./botw/117-quest.jpg": 57591,
	"./botw/117-title.jpg": 37446,
	"./botw/118-exterior.jpg": 81055,
	"./botw/118-interior.jpg": 79886,
	"./botw/118-title.jpg": 15062,
	"./botw/119-exterior.jpg": 84085,
	"./botw/119-interior.jpg": 55573,
	"./botw/119-title.jpg": 71190,
	"./botw/120-exterior.jpg": 58728,
	"./botw/120-interior.jpg": 89808,
	"./botw/120-title.jpg": 20429,
	"./botw/121-exterior.jpg": 11456,
	"./botw/121-interior.jpg": 72647,
	"./botw/121-title.jpg": 25622,
	"./botw/122-exterior.jpg": 47965,
	"./botw/122-interior.jpg": 56246,
	"./botw/122-title.jpg": 9099,
	"./botw/123-exterior.jpg": 99792,
	"./botw/123-interior.jpg": 67110,
	"./botw/123-title.jpg": 83408,
	"./botw/124-exterior.jpg": 60232,
	"./botw/124-interior.jpg": 4550,
	"./botw/124-title.jpg": 10137,
	"./botw/125-exterior.jpg": 20691,
	"./botw/125-interior.jpg": 51240,
	"./botw/125-title.jpg": 35815,
	"./botw/126-exterior.jpg": 32434,
	"./botw/126-interior.jpg": 81641,
	"./botw/126-title.jpg": 1785,
	"./botw/127-exterior.jpg": 98288,
	"./botw/127-interior.jpg": 31924,
	"./botw/127-title.jpg": 98204,
	"./botw/128-exterior.jpg": 57371,
	"./botw/128-interior.jpg": 31037,
	"./botw/128-title.jpg": 59365,
	"./botw/129-exterior.jpg": 4876,
	"./botw/129-interior.jpg": 13838,
	"./botw/129-title.jpg": 48884,
	"./botw/130-exterior.jpg": 92679,
	"./botw/130-interior.jpg": 30176,
	"./botw/130-title.jpg": 11319,
	"./botw/131-exterior.jpg": 3743,
	"./botw/131-interior.jpg": 17690,
	"./botw/131-title.jpg": 4806,
	"./botw/132-exterior.jpg": 18083,
	"./botw/132-interior.jpg": 39760,
	"./botw/132-title.jpg": 70548,
	"./botw/133-exterior.jpg": 62553,
	"./botw/133-interior.jpg": 25670,
	"./botw/133-title.jpg": 44988,
	"./botw/134-exterior.jpg": 23795,
	"./botw/134-interior.jpg": 57587,
	"./botw/134-title.jpg": 85293,
	"./botw/135-exterior.jpg": 48810,
	"./botw/135-interior.jpg": 45118,
	"./botw/135-title.jpg": 36877,
	"./botw/136-exterior.jpg": 55630,
	"./botw/136-interior.jpg": 11475,
	"./botw/136-title.jpg": 92232,
	"./totk/000-exterior.jpg": 23499,
	"./totk/000-interior.jpg": 38118,
	"./totk/000-map.jpg": 6383,
	"./totk/000-title.jpg": 22085,
	"./totk/001-exterior.jpg": 69310,
	"./totk/001-interior.jpg": 94179,
	"./totk/001-map.jpg": 12154,
	"./totk/001-title.jpg": 10185,
	"./totk/002-exterior.jpg": 31709,
	"./totk/002-interior.jpg": 78175,
	"./totk/002-map.jpg": 16453,
	"./totk/002-title.jpg": 68469,
	"./totk/003-exterior.jpg": 98516,
	"./totk/003-interior.jpg": 18702,
	"./totk/003-map.jpg": 38025,
	"./totk/003-title.jpg": 75641,
	"./totk/004-exterior.jpg": 30678,
	"./totk/004-interior.jpg": 39336,
	"./totk/004-map.jpg": 68904,
	"./totk/004-title.jpg": 39078,
	"./totk/005-exterior.jpg": 77459,
	"./totk/005-interior.jpg": 55759,
	"./totk/005-map.jpg": 57058,
	"./totk/005-title.jpg": 15463,
	"./totk/006-exterior.jpg": 45546,
	"./totk/006-interior.jpg": 13496,
	"./totk/006-map.jpg": 35216,
	"./totk/006-title.jpg": 4472,
	"./totk/007-exterior.jpg": 10380,
	"./totk/007-interior.jpg": 66476,
	"./totk/007-map.jpg": 40458,
	"./totk/007-title.jpg": 62506,
	"./totk/008-exterior.jpg": 53756,
	"./totk/008-interior.jpg": 4049,
	"./totk/008-map.jpg": 44984,
	"./totk/008-title.jpg": 57395,
	"./totk/009-exterior.jpg": 48323,
	"./totk/009-interior.jpg": 75546,
	"./totk/009-map.jpg": 60509,
	"./totk/009-title.jpg": 51763,
	"./totk/010-exterior.jpg": 79850,
	"./totk/010-interior.jpg": 76580,
	"./totk/010-map.jpg": 4517,
	"./totk/010-title.jpg": 52818,
	"./totk/011-exterior.jpg": 74600,
	"./totk/011-interior.jpg": 48925,
	"./totk/011-map.jpg": 57603,
	"./totk/011-title.jpg": 31296,
	"./totk/012-exterior.jpg": 10711,
	"./totk/012-interior.jpg": 25735,
	"./totk/012-map.jpg": 16658,
	"./totk/012-title.jpg": 89055,
	"./totk/013-exterior.jpg": 92482,
	"./totk/013-interior.jpg": 54250,
	"./totk/013-map.jpg": 67458,
	"./totk/013-title.jpg": 90586,
	"./totk/014-cave_or_island.jpg": 93662,
	"./totk/014-exterior.jpg": 99933,
	"./totk/014-interior.jpg": 70624,
	"./totk/014-map.jpg": 62302,
	"./totk/014-title.jpg": 95438,
	"./totk/015-exterior.jpg": 91952,
	"./totk/015-interior.jpg": 8531,
	"./totk/015-map.jpg": 73860,
	"./totk/015-title.jpg": 13108,
	"./totk/016-exterior.jpg": 28888,
	"./totk/016-interior.jpg": 20821,
	"./totk/016-map.jpg": 15880,
	"./totk/016-title.jpg": 14199,
	"./totk/017-exterior.jpg": 62634,
	"./totk/017-interior.jpg": 7095,
	"./totk/017-map.jpg": 41886,
	"./totk/017-title.jpg": 14193,
	"./totk/018-exterior.jpg": 51961,
	"./totk/018-interior.jpg": 15176,
	"./totk/018-map.jpg": 2022,
	"./totk/018-title.jpg": 58181,
	"./totk/019-exterior.jpg": 27886,
	"./totk/019-interior.jpg": 47180,
	"./totk/019-map.jpg": 94159,
	"./totk/019-title.jpg": 60448,
	"./totk/020-exterior.jpg": 2155,
	"./totk/020-interior.jpg": 91291,
	"./totk/020-interior_alt.jpg": 96486,
	"./totk/020-map.jpg": 51934,
	"./totk/020-title.jpg": 1571,
	"./totk/021-exterior.jpg": 73501,
	"./totk/021-interior.jpg": 98263,
	"./totk/021-map.jpg": 31075,
	"./totk/021-title.jpg": 13606,
	"./totk/022-exterior.jpg": 32477,
	"./totk/022-interior.jpg": 87874,
	"./totk/022-map.jpg": 33344,
	"./totk/022-title.jpg": 42993,
	"./totk/023-exterior.jpg": 26384,
	"./totk/023-interior.jpg": 41139,
	"./totk/023-map.jpg": 86848,
	"./totk/023-title.jpg": 98867,
	"./totk/024-exterior.jpg": 94377,
	"./totk/024-interior.jpg": 91259,
	"./totk/024-map.jpg": 37148,
	"./totk/024-title.jpg": 87951,
	"./totk/025-exterior.jpg": 22775,
	"./totk/025-interior.jpg": 55810,
	"./totk/025-map.jpg": 8926,
	"./totk/025-title.jpg": 49140,
	"./totk/026-exterior.jpg": 30391,
	"./totk/026-interior.jpg": 20215,
	"./totk/026-map.jpg": 61069,
	"./totk/026-title.jpg": 13954,
	"./totk/027-cave_or_island.jpg": 70475,
	"./totk/027-exterior.jpg": 67453,
	"./totk/027-interior.jpg": 21071,
	"./totk/027-map.jpg": 15000,
	"./totk/027-title.jpg": 72481,
	"./totk/028-exterior.jpg": 80206,
	"./totk/028-interior.jpg": 62213,
	"./totk/028-map.jpg": 14705,
	"./totk/028-title.jpg": 22336,
	"./totk/029-exterior.jpg": 83604,
	"./totk/029-interior.jpg": 94500,
	"./totk/029-map.jpg": 69799,
	"./totk/029-title.jpg": 34923,
	"./totk/030-exterior.jpg": 43722,
	"./totk/030-interior.jpg": 45071,
	"./totk/030-map.jpg": 27536,
	"./totk/030-title.jpg": 26226,
	"./totk/031-exterior.jpg": 64962,
	"./totk/031-interior.jpg": 89237,
	"./totk/031-map.jpg": 66534,
	"./totk/031-title.jpg": 95593,
	"./totk/032-cave_or_island.jpg": 30299,
	"./totk/032-exterior.jpg": 28779,
	"./totk/032-interior.jpg": 6251,
	"./totk/032-map.jpg": 6799,
	"./totk/032-title.jpg": 86260,
	"./totk/033-exterior.jpg": 23202,
	"./totk/033-interior.jpg": 10558,
	"./totk/033-map.jpg": 99909,
	"./totk/033-title.jpg": 57652,
	"./totk/034-exterior.jpg": 22016,
	"./totk/034-interior.jpg": 31041,
	"./totk/034-map.jpg": 61601,
	"./totk/034-title.jpg": 91329,
	"./totk/035-exterior.jpg": 58365,
	"./totk/035-interior.jpg": 90409,
	"./totk/035-map.jpg": 18688,
	"./totk/035-title.jpg": 53528,
	"./totk/036-exterior.jpg": 88424,
	"./totk/036-interior.jpg": 47184,
	"./totk/036-map.jpg": 96943,
	"./totk/036-title.jpg": 25604,
	"./totk/037-exterior.jpg": 80832,
	"./totk/037-interior.jpg": 72938,
	"./totk/037-map.jpg": 50030,
	"./totk/037-title.jpg": 81105,
	"./totk/038-exterior.jpg": 83633,
	"./totk/038-interior.jpg": 52044,
	"./totk/038-map.jpg": 96646,
	"./totk/038-title.jpg": 81790,
	"./totk/039-exterior.jpg": 57217,
	"./totk/039-interior.jpg": 7645,
	"./totk/039-map.jpg": 97789,
	"./totk/039-title.jpg": 21720,
	"./totk/040-exterior.jpg": 10385,
	"./totk/040-interior.jpg": 61494,
	"./totk/040-map.jpg": 73968,
	"./totk/040-title.jpg": 19706,
	"./totk/041-exterior.jpg": 71841,
	"./totk/041-interior.jpg": 6605,
	"./totk/041-map.jpg": 87476,
	"./totk/041-title.jpg": 73808,
	"./totk/042-exterior.jpg": 56959,
	"./totk/042-interior.jpg": 18813,
	"./totk/042-map.jpg": 33702,
	"./totk/042-title.jpg": 96542,
	"./totk/043-exterior.jpg": 79561,
	"./totk/043-interior.jpg": 44398,
	"./totk/043-map.jpg": 83838,
	"./totk/043-title.jpg": 50039,
	"./totk/044-exterior.jpg": 57236,
	"./totk/044-interior.jpg": 15379,
	"./totk/044-map.jpg": 87628,
	"./totk/044-title.jpg": 38369,
	"./totk/045-exterior.jpg": 77358,
	"./totk/045-interior.jpg": 39973,
	"./totk/045-map.jpg": 87416,
	"./totk/045-title.jpg": 7773,
	"./totk/046-exterior.jpg": 69875,
	"./totk/046-interior.jpg": 9211,
	"./totk/046-map.jpg": 65649,
	"./totk/046-title.jpg": 97841,
	"./totk/047-exterior.jpg": 17390,
	"./totk/047-interior.jpg": 40918,
	"./totk/047-map.jpg": 22381,
	"./totk/047-title.jpg": 14288,
	"./totk/048-exterior.jpg": 28593,
	"./totk/048-interior.jpg": 11229,
	"./totk/048-map.jpg": 15679,
	"./totk/048-title.jpg": 65344,
	"./totk/049-exterior.jpg": 95127,
	"./totk/049-interior.jpg": 59643,
	"./totk/049-map.jpg": 5580,
	"./totk/049-title.jpg": 34954,
	"./totk/050-exterior.jpg": 2127,
	"./totk/050-interior.jpg": 58967,
	"./totk/050-map.jpg": 22747,
	"./totk/050-title.jpg": 30124,
	"./totk/051-exterior.jpg": 29683,
	"./totk/051-interior.jpg": 58607,
	"./totk/051-map.jpg": 79999,
	"./totk/051-title.jpg": 13055,
	"./totk/052-exterior.jpg": 63627,
	"./totk/052-interior.jpg": 78104,
	"./totk/052-map.jpg": 39281,
	"./totk/052-title.jpg": 32914,
	"./totk/053-exterior.jpg": 68902,
	"./totk/053-interior.jpg": 85830,
	"./totk/053-map.jpg": 23034,
	"./totk/053-title.jpg": 90539,
	"./totk/054-exterior.jpg": 86847,
	"./totk/054-interior.jpg": 7164,
	"./totk/054-map.jpg": 96106,
	"./totk/054-title.jpg": 70586,
	"./totk/055-exterior.jpg": 17978,
	"./totk/055-interior.jpg": 50012,
	"./totk/055-map.jpg": 86451,
	"./totk/055-title.jpg": 72773,
	"./totk/056-exterior.jpg": 17002,
	"./totk/056-interior.jpg": 88625,
	"./totk/056-map.jpg": 69118,
	"./totk/056-title.jpg": 89940,
	"./totk/057-exterior.jpg": 21013,
	"./totk/057-interior.jpg": 52075,
	"./totk/057-map.jpg": 87735,
	"./totk/057-title.jpg": 20871,
	"./totk/058-exterior.jpg": 66450,
	"./totk/058-interior.jpg": 34426,
	"./totk/058-map.jpg": 9262,
	"./totk/058-title.jpg": 57689,
	"./totk/059-exterior.jpg": 21853,
	"./totk/059-interior.jpg": 4700,
	"./totk/059-map.jpg": 41017,
	"./totk/059-title.jpg": 60417,
	"./totk/060-exterior.jpg": 3719,
	"./totk/060-interior.jpg": 24004,
	"./totk/060-map.jpg": 1688,
	"./totk/060-title.jpg": 51036,
	"./totk/061-exterior.jpg": 90133,
	"./totk/061-interior.jpg": 57245,
	"./totk/061-map.jpg": 21870,
	"./totk/061-title.jpg": 61169,
	"./totk/062-exterior.jpg": 75286,
	"./totk/062-interior.jpg": 48938,
	"./totk/062-map.jpg": 82534,
	"./totk/062-title.jpg": 48981,
	"./totk/063-exterior.jpg": 95441,
	"./totk/063-interior.jpg": 65789,
	"./totk/063-map.jpg": 69297,
	"./totk/063-title.jpg": 11919,
	"./totk/064-exterior.jpg": 37951,
	"./totk/064-interior.jpg": 55337,
	"./totk/064-map.jpg": 32172,
	"./totk/064-title.jpg": 55768,
	"./totk/065-exterior.jpg": 7894,
	"./totk/065-interior.jpg": 45650,
	"./totk/065-map.jpg": 79795,
	"./totk/065-title.jpg": 29767,
	"./totk/066-exterior.jpg": 92196,
	"./totk/066-interior.jpg": 49237,
	"./totk/066-map.jpg": 1261,
	"./totk/066-quest.jpg": 73330,
	"./totk/066-title.jpg": 45755,
	"./totk/067-cave_or_island.jpg": 4430,
	"./totk/067-exterior.jpg": 66407,
	"./totk/067-interior.jpg": 64140,
	"./totk/067-map.jpg": 46004,
	"./totk/067-quest.jpg": 53869,
	"./totk/067-title.jpg": 20213,
	"./totk/068-cave_or_island.jpg": 11614,
	"./totk/068-exterior.jpg": 94111,
	"./totk/068-interior.jpg": 4785,
	"./totk/068-map.jpg": 75011,
	"./totk/068-title.jpg": 54875,
	"./totk/069-cave_or_island.jpg": 48899,
	"./totk/069-exterior.jpg": 52811,
	"./totk/069-interior.jpg": 88904,
	"./totk/069-map.jpg": 10488,
	"./totk/069-title.jpg": 8094,
	"./totk/070-cave_or_island.jpg": 81174,
	"./totk/070-exterior.jpg": 56827,
	"./totk/070-interior.jpg": 71221,
	"./totk/070-map.jpg": 64877,
	"./totk/070-title.jpg": 9273,
	"./totk/071-cave_or_island.jpg": 87571,
	"./totk/071-exterior.jpg": 35418,
	"./totk/071-interior.jpg": 9213,
	"./totk/071-map.jpg": 58133,
	"./totk/071-title.jpg": 81089,
	"./totk/072-exterior.jpg": 23935,
	"./totk/072-interior.jpg": 70504,
	"./totk/072-map.jpg": 22793,
	"./totk/072-title.jpg": 7658,
	"./totk/073-cave_or_island.jpg": 18010,
	"./totk/073-exterior.jpg": 5417,
	"./totk/073-interior.jpg": 35795,
	"./totk/073-map.jpg": 55378,
	"./totk/073-title.jpg": 81775,
	"./totk/074-exterior.jpg": 93516,
	"./totk/074-interior.jpg": 70463,
	"./totk/074-map.jpg": 9466,
	"./totk/074-title.jpg": 32535,
	"./totk/075-exterior.jpg": 92408,
	"./totk/075-interior.jpg": 55611,
	"./totk/075-map.jpg": 34469,
	"./totk/075-title.jpg": 95291,
	"./totk/076-cave_or_island.jpg": 95311,
	"./totk/076-exterior.jpg": 74235,
	"./totk/076-interior.jpg": 86626,
	"./totk/076-map.jpg": 39494,
	"./totk/076-quest.jpg": 55223,
	"./totk/076-title.jpg": 47127,
	"./totk/077-exterior.jpg": 54454,
	"./totk/077-interior.jpg": 11034,
	"./totk/077-map.jpg": 53972,
	"./totk/077-title.jpg": 59477,
	"./totk/078-cave_or_island.jpg": 6449,
	"./totk/078-exterior.jpg": 31899,
	"./totk/078-interior.jpg": 31317,
	"./totk/078-map.jpg": 55056,
	"./totk/078-title.jpg": 45189,
	"./totk/079-exterior.jpg": 46042,
	"./totk/079-interior.jpg": 921,
	"./totk/079-map.jpg": 65477,
	"./totk/079-quest.jpg": 80853,
	"./totk/079-title.jpg": 1109,
	"./totk/080-exterior.jpg": 21921,
	"./totk/080-interior.jpg": 61239,
	"./totk/080-map.jpg": 62555,
	"./totk/080-title.jpg": 8726,
	"./totk/081-exterior.jpg": 1248,
	"./totk/081-interior.jpg": 4542,
	"./totk/081-map.jpg": 56866,
	"./totk/081-quest.jpg": 91506,
	"./totk/081-title.jpg": 18509,
	"./totk/082-cave_or_island.jpg": 86404,
	"./totk/082-exterior.jpg": 87198,
	"./totk/082-interior.jpg": 8972,
	"./totk/082-map.jpg": 16008,
	"./totk/082-title.jpg": 26954,
	"./totk/083-cave_or_island.jpg": 26349,
	"./totk/083-exterior.jpg": 42924,
	"./totk/083-interior.jpg": 83766,
	"./totk/083-map.jpg": 90332,
	"./totk/083-title.jpg": 92002,
	"./totk/084-cave_or_island.jpg": 75153,
	"./totk/084-exterior.jpg": 34125,
	"./totk/084-interior.jpg": 56791,
	"./totk/084-map.jpg": 33896,
	"./totk/084-title.jpg": 3900,
	"./totk/085-exterior.jpg": 22841,
	"./totk/085-interior.jpg": 80547,
	"./totk/085-map.jpg": 94423,
	"./totk/085-title.jpg": 71365,
	"./totk/086-cave_or_island.jpg": 26534,
	"./totk/086-exterior.jpg": 84082,
	"./totk/086-interior.jpg": 80369,
	"./totk/086-map.jpg": 21385,
	"./totk/086-title.jpg": 78886,
	"./totk/087-exterior.jpg": 88598,
	"./totk/087-interior.jpg": 73194,
	"./totk/087-map.jpg": 19765,
	"./totk/087-title.jpg": 71382,
	"./totk/088-exterior.jpg": 30606,
	"./totk/088-interior.jpg": 50555,
	"./totk/088-map.jpg": 9917,
	"./totk/088-title.jpg": 27457,
	"./totk/089-exterior.jpg": 8765,
	"./totk/089-interior.jpg": 18733,
	"./totk/089-map.jpg": 68961,
	"./totk/089-quest.jpg": 25326,
	"./totk/089-title.jpg": 82343,
	"./totk/090-exterior.jpg": 22854,
	"./totk/090-interior.jpg": 27396,
	"./totk/090-map.jpg": 75797,
	"./totk/090-title.jpg": 43126,
	"./totk/091-cave_or_island.jpg": 63307,
	"./totk/091-exterior.jpg": 26169,
	"./totk/091-interior.jpg": 29638,
	"./totk/091-map.jpg": 37625,
	"./totk/091-title.jpg": 43056,
	"./totk/092-cave_or_island.jpg": 47849,
	"./totk/092-exterior.jpg": 90334,
	"./totk/092-interior.jpg": 56464,
	"./totk/092-map.jpg": 39721,
	"./totk/092-quest.jpg": 19884,
	"./totk/092-title.jpg": 26455,
	"./totk/093-exterior.jpg": 90164,
	"./totk/093-interior.jpg": 5340,
	"./totk/093-map.jpg": 9459,
	"./totk/093-quest.jpg": 86031,
	"./totk/093-title.jpg": 21790,
	"./totk/094-cave_or_island.jpg": 327,
	"./totk/094-exterior.jpg": 26903,
	"./totk/094-interior.jpg": 53715,
	"./totk/094-map.jpg": 21583,
	"./totk/094-title.jpg": 68472,
	"./totk/095-cave_or_island.jpg": 68002,
	"./totk/095-exterior.jpg": 64502,
	"./totk/095-interior.jpg": 30157,
	"./totk/095-map.jpg": 66633,
	"./totk/095-title.jpg": 62018,
	"./totk/096-exterior.jpg": 23680,
	"./totk/096-interior.jpg": 44087,
	"./totk/096-map.jpg": 15048,
	"./totk/096-title.jpg": 57986,
	"./totk/097-cave_or_island.jpg": 13056,
	"./totk/097-exterior.jpg": 44214,
	"./totk/097-interior.jpg": 22104,
	"./totk/097-map.jpg": 35498,
	"./totk/097-title.jpg": 45541,
	"./totk/098-cave_or_island.jpg": 63247,
	"./totk/098-exterior.jpg": 75513,
	"./totk/098-interior.jpg": 54585,
	"./totk/098-map.jpg": 43849,
	"./totk/098-quest.jpg": 49921,
	"./totk/098-title.jpg": 44522,
	"./totk/099-cave_or_island.jpg": 72078,
	"./totk/099-exterior.jpg": 33911,
	"./totk/099-interior.jpg": 28243,
	"./totk/099-map.jpg": 17679,
	"./totk/099-quest.jpg": 71476,
	"./totk/099-title.jpg": 60738,
	"./totk/100-exterior.jpg": 19825,
	"./totk/100-interior.jpg": 35859,
	"./totk/100-map.jpg": 71511,
	"./totk/100-quest.jpg": 35219,
	"./totk/100-title.jpg": 73936,
	"./totk/101-cave_or_island.jpg": 84107,
	"./totk/101-exterior.jpg": 43567,
	"./totk/101-interior.jpg": 27568,
	"./totk/101-map.jpg": 44473,
	"./totk/101-quest.jpg": 2235,
	"./totk/101-title.jpg": 9355,
	"./totk/102-cave_or_island.jpg": 32523,
	"./totk/102-exterior.jpg": 37358,
	"./totk/102-interior.jpg": 81651,
	"./totk/102-map.jpg": 69629,
	"./totk/102-title.jpg": 90259,
	"./totk/103-exterior.jpg": 4302,
	"./totk/103-interior.jpg": 85914,
	"./totk/103-map.jpg": 84500,
	"./totk/103-quest.jpg": 38162,
	"./totk/103-title.jpg": 4788,
	"./totk/104-cave_or_island.jpg": 67273,
	"./totk/104-exterior.jpg": 22252,
	"./totk/104-interior.jpg": 75707,
	"./totk/104-map.jpg": 81168,
	"./totk/104-title.jpg": 75791,
	"./totk/105-exterior.jpg": 24342,
	"./totk/105-interior.jpg": 15751,
	"./totk/105-map.jpg": 41453,
	"./totk/105-title.jpg": 42659,
	"./totk/106-exterior.jpg": 57928,
	"./totk/106-interior.jpg": 69802,
	"./totk/106-map.jpg": 43562,
	"./totk/106-quest.jpg": 39856,
	"./totk/106-title.jpg": 88087,
	"./totk/107-cave_or_island.jpg": 11057,
	"./totk/107-exterior.jpg": 36115,
	"./totk/107-map.jpg": 30287,
	"./totk/107-quest.jpg": 59519,
	"./totk/107-title.jpg": 24713,
	"./totk/108-exterior.jpg": 59146,
	"./totk/108-interior.jpg": 36824,
	"./totk/108-map.jpg": 41767,
	"./totk/108-quest.jpg": 90081,
	"./totk/108-title.jpg": 4775,
	"./totk/109-cave_or_island.jpg": 26931,
	"./totk/109-exterior.jpg": 72407,
	"./totk/109-interior.jpg": 672,
	"./totk/109-map.jpg": 69478,
	"./totk/109-title.jpg": 37411,
	"./totk/110-exterior.jpg": 22283,
	"./totk/110-interior.jpg": 33814,
	"./totk/110-map.jpg": 13199,
	"./totk/110-quest.jpg": 38342,
	"./totk/110-title.jpg": 89845,
	"./totk/111-cave_or_island.jpg": 11999,
	"./totk/111-exterior.jpg": 50275,
	"./totk/111-interior.jpg": 50420,
	"./totk/111-map.jpg": 61603,
	"./totk/111-quest.jpg": 30720,
	"./totk/111-title.jpg": 27168,
	"./totk/112-exterior.jpg": 68797,
	"./totk/112-interior.jpg": 37708,
	"./totk/112-map.jpg": 29616,
	"./totk/112-quest.jpg": 76053,
	"./totk/112-title.jpg": 74069,
	"./totk/113-cave_or_island.jpg": 56106,
	"./totk/113-exterior.jpg": 86003,
	"./totk/113-interior.jpg": 47294,
	"./totk/113-map.jpg": 62228,
	"./totk/113-title.jpg": 34639,
	"./totk/114-cave_or_island.jpg": 76878,
	"./totk/114-exterior.jpg": 37314,
	"./totk/114-interior.jpg": 95433,
	"./totk/114-map.jpg": 86602,
	"./totk/114-title.jpg": 59414,
	"./totk/115-exterior.jpg": 12188,
	"./totk/115-interior.jpg": 82205,
	"./totk/115-map.jpg": 87589,
	"./totk/115-quest.jpg": 89872,
	"./totk/115-title.jpg": 35314,
	"./totk/116-cave_or_island.jpg": 73898,
	"./totk/116-exterior.jpg": 83601,
	"./totk/116-interior.jpg": 52632,
	"./totk/116-map.jpg": 36499,
	"./totk/116-title.jpg": 76055,
	"./totk/117-exterior.jpg": 58452,
	"./totk/117-interior.jpg": 59946,
	"./totk/117-map.jpg": 16663,
	"./totk/117-quest.jpg": 78136,
	"./totk/117-title.jpg": 54465,
	"./totk/118-exterior.jpg": 37515,
	"./totk/118-interior.jpg": 15938,
	"./totk/118-map.jpg": 45900,
	"./totk/118-title.jpg": 85505,
	"./totk/119-exterior.jpg": 69091,
	"./totk/119-interior.jpg": 5887,
	"./totk/119-map.jpg": 22124,
	"./totk/119-quest.jpg": 976,
	"./totk/119-title.jpg": 75827,
	"./totk/120-cave_or_island.jpg": 2223,
	"./totk/120-exterior.jpg": 41288,
	"./totk/120-interior.jpg": 21576,
	"./totk/120-map.jpg": 53877,
	"./totk/120-title.jpg": 63118,
	"./totk/121-cave_or_island.jpg": 84764,
	"./totk/121-exterior.jpg": 43622,
	"./totk/121-interior.jpg": 89990,
	"./totk/121-map.jpg": 72015,
	"./totk/121-title.jpg": 17976,
	"./totk/122-exterior.jpg": 37484,
	"./totk/122-interior.jpg": 22716,
	"./totk/122-map.jpg": 66765,
	"./totk/122-title.jpg": 34182,
	"./totk/123-exterior.jpg": 22512,
	"./totk/123-interior.jpg": 96882,
	"./totk/123-map.jpg": 53244,
	"./totk/123-title.jpg": 41081,
	"./totk/124-exterior.jpg": 14470,
	"./totk/124-interior.jpg": 83043,
	"./totk/124-map.jpg": 85147,
	"./totk/124-title.jpg": 90858,
	"./totk/125-exterior.jpg": 50653,
	"./totk/125-interior.jpg": 34555,
	"./totk/125-map.jpg": 28285,
	"./totk/125-title.jpg": 81602,
	"./totk/126-exterior.jpg": 1909,
	"./totk/126-interior.jpg": 11872,
	"./totk/126-map.jpg": 38612,
	"./totk/126-title.jpg": 99745,
	"./totk/127-exterior.jpg": 95673,
	"./totk/127-interior.jpg": 29952,
	"./totk/127-map.jpg": 49411,
	"./totk/127-quest.jpg": 27799,
	"./totk/127-title.jpg": 45411,
	"./totk/128-cave_or_island.jpg": 74876,
	"./totk/128-exterior.jpg": 40600,
	"./totk/128-interior.jpg": 7597,
	"./totk/128-map.jpg": 35549,
	"./totk/128-title.jpg": 71152,
	"./totk/129-exterior.jpg": 35699,
	"./totk/129-interior.jpg": 30631,
	"./totk/129-map.jpg": 64958,
	"./totk/129-title.jpg": 5254,
	"./totk/130-exterior.jpg": 69745,
	"./totk/130-interior.jpg": 6592,
	"./totk/130-map.jpg": 34661,
	"./totk/130-quest.jpg": 64392,
	"./totk/130-title.jpg": 77424,
	"./totk/131-exterior.jpg": 56289,
	"./totk/131-interior.jpg": 30144,
	"./totk/131-map.jpg": 12362,
	"./totk/131-quest.jpg": 72454,
	"./totk/131-title.jpg": 84706,
	"./totk/132-exterior.jpg": 84927,
	"./totk/132-interior.jpg": 98351,
	"./totk/132-map.jpg": 12748,
	"./totk/132-quest.jpg": 2971,
	"./totk/132-title.jpg": 15804,
	"./totk/133-cave_or_island.jpg": 70921,
	"./totk/133-exterior.jpg": 11813,
	"./totk/133-interior.jpg": 88033,
	"./totk/133-map.jpg": 56760,
	"./totk/133-title.jpg": 3764,
	"./totk/134-exterior.jpg": 77035,
	"./totk/134-interior.jpg": 32510,
	"./totk/134-map.jpg": 71363,
	"./totk/134-quest.jpg": 39569,
	"./totk/134-title.jpg": 99600,
	"./totk/135-exterior.jpg": 65606,
	"./totk/135-interior.jpg": 66177,
	"./totk/135-map.jpg": 93241,
	"./totk/135-title.jpg": 20321,
	"./totk/136-exterior.jpg": 47452,
	"./totk/136-interior.jpg": 41329,
	"./totk/136-map.jpg": 44138,
	"./totk/136-title.jpg": 64809,
	"./totk/137-exterior.jpg": 96318,
	"./totk/137-interior.jpg": 45145,
	"./totk/137-map.jpg": 47140,
	"./totk/137-title.jpg": 16491,
	"./totk/138-exterior.jpg": 57690,
	"./totk/138-interior.jpg": 69954,
	"./totk/138-map.jpg": 35289,
	"./totk/138-title.jpg": 28849,
	"./totk/139-exterior.jpg": 30709,
	"./totk/139-interior.jpg": 36670,
	"./totk/139-map.jpg": 75554,
	"./totk/139-title.jpg": 76156,
	"./totk/140-exterior.jpg": 90957,
	"./totk/140-interior.jpg": 63545,
	"./totk/140-map.jpg": 68339,
	"./totk/140-title.jpg": 18559,
	"./totk/141-exterior.jpg": 10690,
	"./totk/141-interior.jpg": 81822,
	"./totk/141-map.jpg": 93425,
	"./totk/141-title.jpg": 57255,
	"./totk/142-exterior.jpg": 11619,
	"./totk/142-interior.jpg": 70513,
	"./totk/142-map.jpg": 62887,
	"./totk/142-title.jpg": 2049,
	"./totk/143-exterior.jpg": 94063,
	"./totk/143-interior.jpg": 30431,
	"./totk/143-map.jpg": 67872,
	"./totk/143-title.jpg": 46890,
	"./totk/144-exterior.jpg": 18567,
	"./totk/144-interior.jpg": 23716,
	"./totk/144-map.jpg": 83871,
	"./totk/144-title.jpg": 86257,
	"./totk/145-exterior.jpg": 3896,
	"./totk/145-interior.jpg": 58119,
	"./totk/145-map.jpg": 84704,
	"./totk/145-quest.jpg": 90431,
	"./totk/145-title.jpg": 95372,
	"./totk/146-cave_or_island.jpg": 70286,
	"./totk/146-exterior.jpg": 37202,
	"./totk/146-interior.jpg": 18125,
	"./totk/146-map.jpg": 56657,
	"./totk/146-title.jpg": 4756,
	"./totk/147-cave_or_island.jpg": 30819,
	"./totk/147-exterior.jpg": 51391,
	"./totk/147-interior.jpg": 88618,
	"./totk/147-map.jpg": 2985,
	"./totk/147-title.jpg": 12801,
	"./totk/148-cave_or_island.jpg": 46435,
	"./totk/148-exterior.jpg": 85222,
	"./totk/148-interior.jpg": 22929,
	"./totk/148-map.jpg": 60835,
	"./totk/148-title.jpg": 88520,
	"./totk/149-exterior.jpg": 67964,
	"./totk/149-interior.jpg": 57376,
	"./totk/149-map.jpg": 85072,
	"./totk/149-quest.jpg": 51414,
	"./totk/149-title.jpg": 12019,
	"./totk/150-exterior.jpg": 45101,
	"./totk/150-interior.jpg": 58528,
	"./totk/150-map.jpg": 88516,
	"./totk/150-quest.jpg": 71920,
	"./totk/150-title.jpg": 6365,
	"./totk/151-exterior.jpg": 31302,
	"./totk/151-interior.jpg": 74780,
	"./totk/151-map.jpg": 89687,
	"./totk/151-quest.jpg": 25781,
	"./totk/151-title.jpg": 54350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74187;